import * as React from 'react';
import { SearchResults } from './search-results';
import {EJourneyToolSearchType} from '../../helpers';
import {
  SearchBox, TextField
} from 'office-ui-fabric-react';


interface IProps {
	searchTerm: string;
	showResultsWithEmptyTerm: boolean;
	labelText: string;
	results: any;
	awaitingResults: boolean;
	debounceDelay: number;
	isCurrentSearchComponent: boolean;
	className?: string;
	displaySharedJourneyItems?: boolean;
	journeyToolSearchType?:EJourneyToolSearchType;
	displayRedirectCandidateItems?: boolean;
	adminToolSearch?: boolean;
	updateResults: (searchTerm: string) => void;
	onResultClick: (key: string, item: any) => void;
	onBlur?: () => void;
}

export class Search extends React.Component<IProps, any> {

	private inputTimeout;

	private debounce = (value: string) => {
		
		if(this.inputTimeout) {
			clearTimeout(this.inputTimeout);
		}

		this.inputTimeout = setTimeout(() => {

			this.props.updateResults(value);

		}, this.props.debounceDelay);

	}

	render() {

		let { 
			results, searchTerm, awaitingResults, isCurrentSearchComponent, onResultClick, showResultsWithEmptyTerm, className, labelText, displaySharedJourneyItems,
			journeyToolSearchType, displayRedirectCandidateItems, onBlur, adminToolSearch
		} = this.props;

		let showResults = isCurrentSearchComponent && (
			showResultsWithEmptyTerm ||
			(searchTerm && searchTerm.length)
		);

		let value:string = isCurrentSearchComponent ? searchTerm : '';

		return (
			<div className={ 'search-wrapper' + className ? ' ' + className : '' }>
				{
					displaySharedJourneyItems || adminToolSearch ?
					<TextField 
						className="search"
						onChanged={ this.debounce }
						onFocus={ () => this.props.updateResults(value) }
						onBlur={ onBlur }
						placeholder={ labelText }
						value={ value }
					/> :
					<SearchBox
						className="search" 
						onChange={ this.debounce }			
						labelText={ labelText }
						value={ isCurrentSearchComponent ? searchTerm : '' }
						 />
				}
				{
		        	showResults ? 
						<SearchResults 
							results={ results } 
							journeyToolSearchType = {journeyToolSearchType}
							displaySharedJourneyItems={ displaySharedJourneyItems }
							displayRedirectCandidateItems={ displayRedirectCandidateItems }
							awaitingResults={ awaitingResults } 
							onResultClick={ onResultClick } /> :
						null
				}
			</div>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/common/search.tsx